import { CoreLink } from '@uncinc/react-drupal-core';
import React from 'react';
import classnames from 'classnames';
import config from 'react-global-configuration';
import { useTranslation } from 'react-i18next';

import { DOMAIN_VNL } from '../../../config/constants';
import SwirlIllustrations from '../../SwirlIllustrations';

import './style.scss';

const Expert = ({ name, email = null, avatar, workfield, className, link, linkedIn, bio, isSmall, isCard, contactForm }) => {
  const { t } = useTranslation();

  return (
    <div className={classnames(className, 'Expert', { ExpertLarge: isCard })}>
      <div className="Expert__details">
        <div className="Expert__details__avatar"><img alt={`Foto van ${name}`} src={avatar} /></div>
        <div className="Expert__details__info">
          <div className="Expert__details__workfield">{ workfield }</div>
          <CoreLink to={link} className="icon-after icon-chevron-right">
            <strong className="Expert__details__name">{ name }</strong>
          </CoreLink>
        </div>
      </div>
      <div className="Expert__content">
        {isCard && (
          <div className="Expert__body subheading2">
            {bio}
          </div>
        )}
        {config.get('CURRENT_DOMAIN') === DOMAIN_VNL && (
          <div className="Expert__links">
            <CoreLink to={`${contactForm}?expert=${name}`} className="icon-after icon-chevron-right">
              <div className="icon icon-mail" />
              {t('implementations.node.expert.contact_us')}
            </CoreLink>
            {linkedIn && linkedIn !== '/' && (
              <CoreLink to={linkedIn} className="icon-after icon-chevron-right">
                <div className="icon icon-linkedin" />
                LinkedIn
              </CoreLink>
            )}
          </div>
        )}
      </div>
      {isCard && (
        <SwirlIllustrations
          variant="expert"
        />
      )}
    </div>
  );
};

export default Expert;
